import { ContentChildren, Directive, Input, OnChanges, QueryList, SimpleChanges } from '@angular/core';
import { ScrollItemDirective } from './scroll-item.directive';

@Directive({
  selector: '[appScrollList]',
  standalone: true
})
export class ScrollListDirective implements OnChanges {
  constructor() { }

  @Input() activeIndex: number = 0;
  @ContentChildren(ScrollItemDirective, { descendants: true }) scrollButtons: QueryList<ScrollItemDirective>;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['activeIndex'] && !changes['activeIndex'].firstChange) {
      this.scrollButtons.get(this.activeIndex)?.setActive();
    }
  }
}
